<template>
    <main id="games-wrapper">
        <div id="games-page">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: '/', status: false },
                    { title: 'Games', url: '/games', status: true }
                ]"
            ></breadcrumb>
            <div class="container py-4">
                <div v-html="user.game_motogp"></div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import Games from "../../widget/Games";
import BreadCrumb from "../../widget/BreadCrumb";

export default {
    components: {
        breadcrumb: BreadCrumb,
        games: Games
    },
    data() {
        return {
            mobile: false,
            user: null,
            loader:false,
            data:{
                hcid:'HCID00097601',
            },
        };
    },
    created() {
        this.mobile = isMobile;
        if(localStorage.getItem('user') != null){
            this.user = JSON.parse(localStorage.getItem('user'));
        }
    },
    methods: {
    }
};
</script>

<style scoped lang="scss">
#games-page{
    background: #000000;
}
iframe{
    width: 100%;
    height: 700px;
}
</style>
